export default {
	state: {
		onboardingData: null,
	},
	getters: {
		getOnboardingData(state) {
			return state.onboardingData;
		},
	},
	mutations: {
		setOnboardingData(state, payload) {
			state.onboardingData = payload;
		},
	},
};
